
// region JS Imports

// region External Modules
import $ from "jquery"

import I18n from "plugins/i18n-js"
import * as Routes from "plugins/js-routes"
// endregion External Modules

// region Private Modules
import Modal from "app/modal/show-modal"
import q_ajax_3 from "app/utils/q_ajax/q_ajax_3"

import {
  FollowTypes,
  unsubscribe,
} from "app/resources/building_followings/unsubscribe"
// endregion Private Modules

// region Public Components
import Notifier from "app/notifier/index"
// endregion Public Components

// region Private Components
// endregion Private Components

// endregion JS Imports



interface Input {
  user_authentication_handle: string,

  building_id: string | number,

  follow_type: FollowTypes,
}

const DEFAULT_SELECTOR = {
  main_modal:     ".cell--buildings--confirm-cancel-follow-modal--desktop_ver",

  follow_type_select_modal: ".cell--buildings--follow-type-select-modal--desktop_ver",

  cancel_button:  ".cell--buildings--confirm-cancel-follow-modal-content-cancel-button",
  confirm_button: ".cell--buildings--confirm-cancel-follow-modal-content-confirm-button",

  follow_buttons: ".cell--buildings--following--button",
}

const init = ({user_authentication_handle, building_id, follow_type}: Input) => {
  const building_name = $(DEFAULT_SELECTOR.follow_type_select_modal).data("building-name")
  q_ajax_3({
    url:      Routes.apps_spacious_website_partials_buildings_confirm_cancel_follow_modal_path(
      {
        building_name: building_name,
        locale:        I18n.locale,
      },
    ),
    method:   "GET",
    dataType: "html",
  })
  .then(({data}) => {
    $(DEFAULT_SELECTOR.follow_type_select_modal).fadeOut(100)
    Modal.showModalWithContent(data, {
      class: "container",
    })

    $(DEFAULT_SELECTOR.confirm_button).on("click", () => {
      unsubscribe({user_authentication_handle, building_id, follow_type}).then(() => {
        const alert_message = I18n.t(
          "apps_spacious_website_partials.buildings.confirm_cancel_follow_modal.content.success_unfollow_message",
          {
            building: building_name || "",
          },
        )

        Notifier.showSpaciousBlackAlert(alert_message, 5000)
        $(DEFAULT_SELECTOR.follow_buttons).filter(`[data-building-id="${building_id}"]`).removeClass("following")
      })
      Modal.hideAllModals()
    })

    $(DEFAULT_SELECTOR.cancel_button).on("click", () => {
      Modal.hideTopModal()
    })

    $(DEFAULT_SELECTOR.main_modal).on("hide.bs.modal", () => {
      $(DEFAULT_SELECTOR.follow_type_select_modal).fadeIn(300)
    })

  })
}


export default {init}
